export const isYouTubeEmbedUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    return (
      urlObj.hostname === "www.youtube.com" &&
      urlObj.pathname.startsWith("/embed/")
    );
  } catch {
    return false;
  }
};
